import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const InputContainer = styled.div`
  width: 100%;

  input {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
`

export const InputsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
